import localforage from 'localforage'

const store = localforage.createInstance({
  name: 'blade-appstream'
})

const Helpers = {

  unwrap: token => {
    const payload = JSON.parse(atob(token.split('.')[1]))
    // console.log(playload);

    return payload
  },

  storage: {

    set: async (key, value) => {
      return store.setItem(key, value)
    },

    get: async (key) => {
      return store.getItem(key)
    }

  }

}

export default Helpers



// WEBPACK FOOTER //
// ./src/helpers/index.js